import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";

import { PostHogProvider } from 'posthog-js/react';

// Global Error Listeners for non-React errors
window.addEventListener('error', (event) => {
  if (event.error) {
    fetch(`${process.env.REACT_APP_API_URL || ''}/api/report-error`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        error: event.error.toString(),
        url: window.location.href,
        userAgent: navigator.userAgent
      }),
    }).catch(() => { });
  }
});

window.addEventListener('unhandledrejection', (event) => {
  fetch(`${process.env.REACT_APP_API_URL || ''}/api/report-error`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      error: `Unhandled Promise Rejection: ${event.reason}`,
      url: window.location.href,
      userAgent: navigator.userAgent
    }),
  }).catch(() => { });
});


const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST || 'https://app.posthog.com',
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
      options={options}
    >
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </PostHogProvider>
  </React.StrictMode>
);
